<template>
  <div
    id="tabela-listagem-guia-container"
    :class="{ 'tabela-listagem-guia-desabilitada': tabelaEstaDesabilitada }"
  >
      <b-row
          class="float-right mb-3"
          :class="{
              'text-muted': tabelaEstaDesabilitada,
                  }"
      >
          <span>Exibir</span>
          <select
              class="ml-2"
              v-model="itensPorPagina"
              :disabled="tabelaEstaDesabilitada"
          >
              <option
                  v-for="qntItens in listaDeItensPorPagina"
                  :value="qntItens"
                  v-bind:key="qntItens"
              >
                  {{ qntItens }}
              </option>
          </select>
          <span class="ml-2 mr-3">Linhas</span>
      </b-row>

    <b-table
      responsive
      striped
      hover
      show-empty
      empty-text="Nenhum dado disponível."
      empty-filtered-text="Tente navamente mais tarde. Erro inesperado na rotina de debitosGrupos."
      stacked="md"
      primary-key="guia"
    
      id="tabela-listagem-guia"
      summary="Tabela Listagem Guia"
      :fields="campos"
      :items="items"
      :current-page="paginaAtual"
      :per-page="itensPorPagina"
      :tbody-tr-class="rowClass"
    >
      <template v-slot:cell(selecionado)="{ item }">
        <b-form-checkbox
          :checked="item.selecionado"
          @change="checkClicked(item)"
        ></b-form-checkbox>
      </template>
    </b-table>

    <tabelaListagemCNPJFooter
      :itensPorPagina="itensPorPagina"
      :totalItens="items.length"
      :paginaAtual="paginaAtual"
      :disabled="tabelaEstaDesabilitada"
      @paginaAtualizada="paginaAtual = $event"
    />
  </div>
</template>
  
<script>
import tabelaListagemCNPJFooter from '../components/compartilhados/tabelaListagemCNPJFooter.vue';

export default {
  components: {
    tabelaListagemCNPJFooter,
  },
  props: {
    items: Array,   
  },

  data() {
    return {
      campos: [
        { key: 'selecionado', label: '', sortable: false },
        { key: 'numeroGuia', label: 'Guia', sortable: true, class: 'text-center' },
        { key: 'lancamento', label: 'Código do Lançamento', sortable: true, class: 'text-center' },
        { key: 'dtEmissao', label: 'Emissão', sortable: true, class: 'text-center' },
        { key: 'dtVencimento', label: 'Vencimento', sortable: true, class: 'text-center' },
        // { key: 'vlSimples', label: 'Simples', sortable: true, class: 'text-right' },   
        // { key: 'vlCorrecao', label: 'Correção', sortable: true, class: 'text-right' },
        // { key: 'vlHonorario', label: 'Honorário', sortable: true, class: 'text-right' },
        // { key: 'vlJuros', label: 'Juros', sortable: true, class: 'text-right' },
        // { key: 'vlMulta', label: 'Multa', sortable: true, class: 'text-right' },                        
        // { key: 'vlSelic', label: 'Selic', sortable: true, class: 'text-right' },
        { key: 'vlTotal', label: 'Total', sortable: true, class: 'text-right' }, 
      ],
      paginaAtual: 1,
      tabelaEstaDesabilitada: false,  
      itensPorPagina: 5,
      listaDeItensPorPagina: [5, 10, 20, 50, 100, 200],
    };
  },

  computed: {   
    rows() {
      return this.items.length;
    },
   
   dadosGuiaSelecionada() {
      return this.items.filter((item) => item.selecionado);
    },     
  },

  watch: {
  },

  methods: {
    checkClicked(item) {
      if (item.selecionado) {
        this.$set(item, "selecionado", false);
      } else {
        this.items.forEach(i => i.selecionado = false);
        this.$set(item, "selecionado", true);
      }  
      this.$emit("update:guiaSelecionada",  this.dadosGuiaSelecionada  );
    },

    //  destacar uma linha na tabela  //
    rowClass(item) {
      if (item.selecionado) return "table-warning";
    },
    //    
  },
};
</script>